import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import styles from './Checkbox.module.scss';
import omit from 'lodash-es/omit';
import Check from '../../../assets/svg/Feather/Check';

function Checkbox(props) {
  const getCheckColor = () => {
    if (props.theme == Checkbox.THEME.white) {
      return '#000';
    } else {
      return '#fff';
    }
  };

  return (
    <div className={styles.container + ' ' + props.className + ' ' + props.theme} >
      { props.label ?
        <label htmlFor={props.id} className={styles.label}>
          { props.label }
        </label> :
        null
      }
      <label htmlFor={props.id} className={styles.checkboxContainer} >
        <input
          {...omit(props, ['className'])}
          type='checkbox'
          value={props.checked}
          disabled={props.disabled}
          name={props.id}
        />
        <span className={styles.checkboxDisplay}>
          <Check color={getCheckColor()} width={14} strokeWidth={4} />
        </span>
      </label>
    </div>
  );
}

Checkbox.THEME = {
  orange: styles.checkOrange,
  white: styles.checkWhite,
};

Checkbox.defaultProps = {
  theme: Checkbox.THEME.orange
};

Checkbox.propTypes = {
  theme: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Checkbox;